import React from 'react'
import {inject, observer} from 'mobx-react';
import {
  Modal, Table, Row, Col, Button, Dropdown
  , Icon, Menu, Input, Select, Radio
} from 'antd';
import {toJS} from 'mobx';
import CSRadioGroup from '../public/cs-radio-group';
import workFlowImg from '../../style/img/workflow.png';

const RadioGroup = Radio.Group;

@inject('homeStore')
@inject('listStore')
@observer
class AppAddModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible,
      title: props.title,
      addModal: props.addModal,
      datas: props.addModal.datas,
      columns: props.addModal.columns,
      key: "",
      name: "",
      type: "",
      selected: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      addModal: nextProps.addModal,
      visible: nextProps.addModal.visible,
      title: nextProps.addModal.title,
      datas: nextProps.addModal.datas,
      columns: nextProps.addModal.columns
    });
  }


  onSearch(params) {
    if (this.props.onSearch) {
      this.props.onSearch(params);
    }
  }


  setValue(record) {
    // console.log("this.props:",this.props);
    // console.log("record:",record);
    this.setState({
      key: record.key,
      name: record.name,
      type: record.type,
      // visible: false,
    })
    this.props.handleOk(record.key, record.name, record.name);
  }

  isSelectedAll() {
    const {listStore} = this.props;
    const { paginationAddModal, rowSelectionAddModal} = listStore;
    let {selectedRows} = rowSelectionAddModal;
    const {datas} = this.state;
    let {pageSizeAddModal, currentAddModal} = paginationAddModal;
    //当前页数据条数
    let sub = datas.length - (currentAddModal - 1) * pageSizeAddModal;
    sub = sub > pageSizeAddModal ? pageSizeAddModal : sub;
    //当前页选中的数据和当前页数据的匹配条数
    let currentDatas = toJS(datas).slice(pageSizeAddModal * (currentAddModal - 1), pageSizeAddModal * (currentAddModal - 1) + sub);
    let intersection = selectedRows.filter(v => {
      let temp = currentDatas.filter(o => {
        return o.key === v.key;
      });
      return temp.length !== 0;
    })
    console.log(selectedRows,intersection,sub);
    this.setState({selected: intersection.length === sub});
  }
  render() {
    const {listStore} = this.props;
    let {rowSelectionAddModal,orderByAppAddModal, paginationAddModal, setPageModal, sreenDatasForAppAddModal, searchValue} = listStore;
    let {pageSizeAddModal} = paginationAddModal;
    let selectedRowsKey = rowSelectionAddModal.selectedRowsKey.slice();
    const menu = (
      <Menu onClick={() => {
      }}>
        <Menu.Item key="1">我的收藏</Menu.Item>
        <Menu.Item key="2">我的项目</Menu.Item>
        {/*<Menu.Item key="3">我的方案</Menu.Item>*/}
      </Menu>
    );
    const columns = [
      {
        key: '1',
        title: '项目名称',
        dataIndex: 'name',
        render(text, record, index) {
          return (
            <div>
              <div style={{display: 'inline-block'}}>
                <img src={workFlowImg} alt=''/>
              </div>
              <div className='list-table-record' style={{display: 'inline-block'}}>
                <div style={{fontWeight: 600}}>{record.name}</div>
                <div className='list-table-record-sub'>
                  <Icon type="eye-o"/>
                  <span>{record.readNum}次</span>
                  <Icon type="download"/>
                  <span style={{color: '#ffab65'}}>{record.downloadNum}</span>次
                </div>
              </div>
            </div>
          )
        }
      },
      {
        key: '2',
        title: '操作',
        width: 120,
        render(text, record, index) {
          return (
            <div>
              <span className='list-table-btn'
                    onClick={() => {
                    }}>添加</span>
              <span className='list-table-btn-line'>|</span>
              <span className='list-table-btn'
                    onClick={() => {
                    }}>移除</span>
            </div>
          )
        }
      }
    ];
    return (
      <Modal title={this.state.title} visible={this.state.visible}
             onCancel={this.handleCancel.bind(this)}
             footer={[
               <Button type='primary' key='1'>批量申请</Button>,
               <Button key='2'>批量移除</Button>
             ]}
             width={750}
             className='app-add-modal'
      >
        <Row className="cs-search-mylist modal-mylist">
          <Col span={9}>
            <label>应用：</label>
            <Input style={{width: 200}}
                   placeholder='请输入应用名称'
                   value={searchValue.application}
                   onChange={(e) => {
                     listStore.searchValue = {...searchValue, application: e.target.value}
                   }}/>
          </Col>
          <Col span={10} style={{marginTop: 5}}>
            <label>类别：</label>
            <RadioGroup
              value={searchValue.category}
              onChange={(e) => {
                let search = 'all';
                search = e.target.value === '1' ? 'workflow' : search;
                search = e.target.value === '2' ? 'portal' : search;
                listStore.callScreenDataForAppAddModal({id: search});
                listStore.callAddWhereData(e.target.value, '');
                listStore.searchValue = {...searchValue, category: e.target.value};
              }}>
              <Radio value='0'>全部</Radio>
              <Radio value='1'>流程</Radio>
              <Radio value='2'>门户</Radio>
            </RadioGroup>
          </Col>
          <Col span={5}>
            <Button type="primary" onClick={() => {
              this.onSearch.bind(this)
            }}>搜索</Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="ghost" onClick={() => {
              listStore.searchValue = {category: '0', application: ''}
            }}>重置</Button>
          </Col>
        </Row>
        <Row style={{"paddingBottom": "8px"}}>
          {/*<Col span="8">*/}
          {/*<SearchInput  style={{"width":"300px"}} onSearch={this.onSearch.bind(this)}/>*/}
          {/*</Col>*/}
          {
            toJS(sreenDatasForAppAddModal).map((item, index) => {
              return (
                <div key={item.key}>
                  {
                    searchValue.category === '0' && (
                      <div
                        className={`list-radio-type-name ${index !== 0 && 'list-radio-type-name2'}`}
                      >{item.name}</div>
                    )
                  }
                  <CSRadioGroup datas={item.data} onChange={(obj) => {
                    console.log('objRadio', obj);

                  }}/>
                </div>
              )
            })
          }
        </Row>
        <Row className="cs-tool modal-tool">
          <Col span={12} className="cs-tool-order">
            <a className={`${orderByAppAddModal === '0' && 'cs-order-active'}`}
               onClick={() => {
                 listStore.orderByAppAddModal = '0';
               }}>热度</a>
            <a className={`${orderByAppAddModal === '1' && 'cs-order-active'}`}
               onClick={() => {
                 listStore.orderByAppAddModal = '1';
               }}>更新日期</a>
            <a className={`${orderByAppAddModal === '2' && 'cs-order-active'}`}
               onClick={() => {
                 listStore.orderByAppAddModal = '2';
               }}>发布日期</a>
          </Col>
          <Col span={12} className="cs-tool-op">
            <Button style={{marginRight: 10}} onClick={() => {

            }}>批量申请</Button>
            <Dropdown overlay={menu}>
              <Button>
                批量添加至 <Icon type="down"/>
              </Button>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table columns={columns} dataSource={toJS(this.state.datas)}
                   loading={this.state.loading} size="middle"
                   onRowClick={this.setValue.bind(this)}
                   className={`list-table ${selectedRowsKey.length !== 0 && this.state.selected && 'list-table2'}`}
                   pagination={
                     {
                       pageSize: pageSizeAddModal,
                       onChange: (current, pageSize) => {
                         setPageModal(current, pageSize);
                         this.isSelectedAll();
                       }
                     }
                   }
                   rowSelection={
                     {
                       type: 'checkbox',
                       selectedRowKeys:selectedRowsKey,
                       onChange: (selectedRowKeys,selectedRows) => {
                         listStore.rowSelectionAddModal = {...listStore.rowSelectionAddModal,selectedRowsKey: selectedRowKeys,selectedRows:selectedRows};
                         this.isSelectedAll();
                       },
                       onSelectAll: selected => {
                         this.setState({selected: selected});
                       }
                     }
                   }
            />
          </Col>
        </Row>
      </Modal>
    )
  }

  handleOk() {
    this.props.handleOk(this.state.selectedData);
  }

  handleCancel() {
    this.props.handleCloseModal();
    this.props.listStore.orderByAppAddModal = '0';
  }
}

export default AppAddModal


// WEBPACK FOOTER //
// ./src/components/util/AppAddModal.js